import React from 'react';
import { Navigate } from 'react-router-dom';

import { PAGE_ROUTES } from '@common/constants';
import { useAuthStore } from '@store/authStore';

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated &&
    window.location.pathname !== PAGE_ROUTES.LANDING_PAGE &&
    window.location.pathname !== PAGE_ROUTES.CUSTOM_EMAIL ? (
    <Navigate to='/templates' />
  ) : (
    children
  );
};

export default PublicRoute;
